// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Eb5T","mainTitle":"styles_mainTitle__1nrmL","catagory":"styles_catagory__15ymv","title":"styles_title__2qp54"};